export default __webpack_public_path__ + "static/media/ret-res1.0004bf22.jpg";